export const USE_IMPLICIT_AUTH_FOR_MSA = true
